export default function blank() {
    return {
        validate(input) {
            return { valid: true };
        },
    };
}



// WEBPACK FOOTER //
// ./node_modules/formvalidation/dist/es6/validators/blank.js